import { FeelingEnum } from "@/generated/graphql/graphql";
import legendToggleFeelingImg from "@/images/legend-toggle-feeling.png";

import { FeelingChip } from "./FeelingChip";
import { LegendBar } from "./LegendBar";
import { LegendToggleButton } from "./LegendToggleButton";

export function FeelingLegendBar() {
  return (
    <LegendBar>
      <div>
        <FeelingChip feelingKey={FeelingEnum.Good} />
        <FeelingChip feelingKey={FeelingEnum.Bad} />
        <FeelingChip feelingKey={FeelingEnum.Unset} />
      </div>

      <div>
        <LegendToggleButton src={legendToggleFeelingImg} />
      </div>
    </LegendBar>
  );
}
